<template>
  <div class="page flex-col">
    <div class="flex-col">
      <div class="text-wrapper_2 flex-col">
        <div class="text-wrapper_2_img"></div>
        <div class="text-wrapper_2_bg"></div>
        <span class="text_11">我们的愿景</span>
        <span class="text_12">成为全国TOP级校园全维度服务管家,成为最受客户及合作伙伴信赖的校园服务运营机构</span>
      </div>
      <div class="group_4 flex-row">
        <img
            class="image_3"
            referrerpolicy="no-referrer"
            src="./assets/img/img1.webp"
        />
        <div class="group_5 flex-col justify-between">
          <div class="text-group_1 flex-col justify-between">
            <span class="text_13">企业使命</span>
            <span class="text_14">Corporate&nbsp;mission</span>
          </div>
          <div class="block_1 flex-col"></div>
          <span class="text_15">聚焦校园，全心全意服务师生</span>
        </div>
        <img
            class="image_4"
            referrerpolicy="no-referrer"
            src="./assets/img/img2.webp"
        />
        <div class="group_6 flex-col justify-between">
          <div class="text-group_2 flex-col justify-between">
            <span class="text_16">企业作风</span>
            <span class="text_17">Enterprise&nbsp;style</span>
          </div>
          <div class="group_7 flex-col"></div>
          <span class="text_18">尊重、分享、协作、共享、共赢</span>
        </div>
      </div>
      <div class="group_8 flex-row">
        <img
            class="image_5"
            referrerpolicy="no-referrer"
            src="./assets/img/img3.webp"
        />
        <div class="box_2 flex-col justify-between">
          <div class="text-group_3 flex-col justify-between">
            <span class="text_19">企业理念</span>
            <span class="text_20">Corporate&nbsp;philosophy</span>
          </div>
          <div class="group_9 flex-col"></div>
          <span class="text_21">多元化经营，谋求发展</span>
        </div>
        <img
            class="image_6"
            referrerpolicy="no-referrer"
            src="./assets/img/img4.webp"
        />
        <div class="box_3 flex-col justify-between">
          <div class="text-group_4 flex-col justify-between">
            <span class="text_22">企业精神</span>
            <span class="text_23">Corporate&nbsp;spirit</span>
          </div>
          <div class="section_2 flex-col"></div>
          <span class="text_24">以服务为宗旨，以质量求生存，以发展求效益，以文化树形象。</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      constants: {}
    };
  },
  methods: {}
};
</script>
<style scoped lang="css" src="./assets/index.css" />
